// extracted by css-extract-rspack-plugin
export default {"skip":"SkipBlock-module__skip____yDG9","invalid":"SkipBlock-module__invalid___tcjxZ"};